module.exports = __webpack_public_path__ + "static/tablet-preview-garden-and-kitchen-b2de9a1227088d6f696c25d3db2f2f15.png";